import React from "react";

export const Edit = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 18 18"
    >
      <path
        d="M2.25 13.5h3a.68.68 0 00.525-.225l8.25-8.25c.3-.3.3-.75 0-1.05l-3-3c-.3-.3-.75-.3-1.05 0l-8.25 8.25a.68.68 0 00-.225.525v3c0 .45.3.75.75.75zM3 10.05l7.5-7.5 1.95 1.95-7.5 7.5H3v-1.95zm12.75 7.2c.45 0 .75-.3.75-.75s-.3-.75-.75-.75H2.25c-.45 0-.75.3-.75.75s.3.75.75.75h13.5z"
        clipRule="evenodd"
      />
    </svg>
  );
};
